<template>
	<div>
		<!-- 面包屑 -->
		<Breadcrumb></Breadcrumb>
		<el-card class="mt-2">
		<div class="w-100 h-auto flex flex-column">
			<el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
				<el-divider content-position="left">基本信息</el-divider>
				<el-row>
					<el-col :span="12">
                        <el-form-item label="产品名称" label-width="100px" prop="name">
                          <el-input v-model="form.name" placeholder="请输入产品名称" type="text" clearable />
                        </el-form-item>
					</el-col>
					<el-col :span="12">
					  <el-form-item label="产品类型" label-width="100px" prop="cat_id">
					    <el-select v-model="form.cat_id" placeholder="请选择产品类型" size="medium" class="w-100">
					    	<el-option label="无" :value="0"></el-option>
					    	<el-option v-for="(item,index) in category" :key="index"
					    		:label="item | tree" 
					    		:value="item.id">
					    	</el-option>
					    </el-select>
					  </el-form-item>
					</el-col>
				</el-row>
				<el-row>
				    <el-col :span="12">
				        <el-form-item label="产品数量" label-width="100px" prop="nums">
				          <el-input v-model="form.nums" placeholder="请输入产品数量" type="number" clearable/>
				        </el-form-item>
				    </el-col>
					<el-col :span="12">
					    <el-form-item label="品牌/材质" label-width="100px" prop="brand">
					      <el-input v-model="form.brand" placeholder="请输入品牌/材质" type="text" clearable />
					    </el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
					  <el-form-item label="产品型号" label-width="100px" prop="model">
					    <el-input v-model="form.model" placeholder="请输入型号" type="text" clearable />
					  </el-form-item>
					</el-col>
					<el-col :span="12">
					    <el-form-item label="产品规格" label-width="100px" prop="guige">
					      <el-input v-model="form.guige" placeholder="请输入规格" type="text" clearable />
					    </el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
					  <el-form-item label="采购日期" label-width="100px" prop="procure_time">
						<el-date-picker
							v-model="form.procure_time"
							type="date"
							value-format="yyyy-MM-dd"
							class="w-100"
							placeholder="请选择采购日期">
						</el-date-picker>
					  </el-form-item>
					</el-col>
					<el-col :span="12">
					    <el-form-item label="采购人员" label-width="100px" prop="procure_name">
					      <el-input v-model="form.procure_name" placeholder="请输入采购人员" type="text" clearable />
					    </el-form-item>
					</el-col>
				</el-row>
				<el-row>
	                <el-col :span="12">
	                    <el-form-item label="采购价格" label-width="100px" prop="price">
	                      <el-input v-model="form.price" placeholder="请输入采购价格" type="number" clearable />
	                    </el-form-item>
	                </el-col>
					<el-col :span="12">
					    <el-form-item label="采购金额" label-width="100px" prop="money">
					      <el-input v-model="form.money" placeholder="请输入采购金额" type="number" clearable />
					    </el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="left">生产厂家</el-divider>
				<el-row>
					<el-col :span="12">
                        <el-form-item label="厂家/供货商" label-width="100px" prop="manufactor">
                          <el-input v-model="form.manufactor" placeholder="请输入生产厂家/供货商" type="text" clearable />
                        </el-form-item>
					</el-col>
					<el-col :span="12">
					  <el-form-item label="单位" label-width="100px" prop="unit">
					    <el-input v-model="form.unit" placeholder="请输入单位(个,件,顶)" type="text" clearable />
					  </el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
					    <el-form-item label="生产批次" label-width="100px" prop="batch">
					      <el-input v-model="form.batch" placeholder="请输入生产批次" type="text" clearable />
					    </el-form-item>
					</el-col>
					<el-col :span="12">
					   <el-form-item label="国标号" label-width="100px" prop="gbcode">
					     <el-input v-model="form.gbcode" placeholder="请输入国标号" type="text" clearable />
					   </el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
	                    <el-form-item label="维修日期" label-width="100px" prop="wx_time">
	                     <el-date-picker
							v-model="form.wx_time"
							type="date"
							value-format="yyyy-MM-dd"
							class="w-100"
							placeholder="请选择维修日期">
	                     </el-date-picker>
	                    </el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="生产日期" label-width="100px" prop="made_time">
						  <el-date-picker
							v-model="form.made_time"
							type="date"
							value-format="yyyy-MM-dd"
							class="w-100"
							placeholder="请选择生产日期">
						  </el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
					    <el-form-item label="有效期限" label-width="100px" prop="expirare_date">
					      <el-date-picker
					            v-model="form.expirare_date"
					            type="daterange"
					    		value-format="yyyy-MM-dd"
					    		class="w-100"
					            range-separator="至"
					            start-placeholder="开始日期"
					            end-placeholder="结束日期">
					      </el-date-picker>
					    </el-form-item>
					</el-col>
					<el-col :span="12">
					    <el-form-item label="保险期限" label-width="100px" prop="bx_date">
					      <el-date-picker
					            v-model="form.bx_date"
					            type="daterange"
					    		value-format="yyyy-MM-dd"
					    		class="w-100"
					            range-separator="至"
					            start-placeholder="开始日期"
					            end-placeholder="结束日期">
					      </el-date-picker>
					    </el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="left">其他信息</el-divider>
				<el-row>
                    <el-col :span="12">
                    	<el-form-item label="状态" prop="status">
                    		<el-radio-group v-model="form.status">
                    			<el-radio :label="1">正常</el-radio>
                    			<el-radio :label="2">停用</el-radio>
                    		</el-radio-group>
                    	</el-form-item>
                    </el-col>
					<el-col :span="12">
                        <el-form-item label="排序" label-width="100px" prop="sort">
                          <el-input v-model="form.sort" placeholder="请输入排序" type="number" clearable />
                        </el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
                        <el-form-item label="备注" prop="brief">
                        	<el-input v-model="form.brief" placeholder="请输入备注" type="textarea" rows="3" maxlength="50" show-word-limit/>
                        </el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="w-100 flex-all mt-2">
			  <el-button size="medium" @click="goBack">取 消</el-button>
			  <el-button type="primary" size="medium" @click="handleSubmit" style="margin-left: 30px;">确 定</el-button>
			</div>
		</div>
		</el-card>
	</div>
</template>

<script>
import common from "@/common/mixins/common.js"
import Breadcrumb from '@/components/Breadcrumb';
export default {
	inject:['app'],
	mixins:[common],
	components: {
		Breadcrumb,
	},
	data() {
		return {
			preUrl: 'kc_kcgl',
			autoRequest: false,
			queryForm: {
				page: 1,
				limit: 10,
				keyword: '',
			},
			form:{
				name:'',
				bn:'',
				brand:'',
				model:'',
				guige:'',
				nums:'',
				cat_id:'',
				unit:'',
				procure_time:'',
				price:'',
				money:'',
				gys_time:'',
				procure_name:'',
				expirare_date:[],
				bx_date:[],
				manufactor:'',
				gbcode:'',
				made_time:'',
				wx_time:'',
				batch:'',
				sort:100,
				status:1,
				brief:'',
			},
			rules:{
				cat_id: [
				  { required: true, message: '请选择产品类型', trigger: ['blur','change'] }
				],
				name: [
				  { required: true, message: '请输入产品名称', trigger: ['blur','change'] }
				],
				nums: [
				  { required: true, message: '请输入产品数量', trigger: ['blur','change'] }
				],
				procure_time: [
				  { required: true, message: '请输入采购日期', trigger: ['blur','change'] }
				],
				procure_name: [
				  { required: true, message: '请输入采购人员', trigger: ['blur','change'] }
				],
				price: [
				  { required: true, message: '请输入采购价格', trigger: ['blur','change'] }
				],
				money: [
				  { required: true, message: '请输入采购金额', trigger: ['blur','change'] }
				],
			},
			category:[],
		}
	},
	mounted() {
		if(this.$route.query.info){
			 this.form = this.$route.query.info
		}
		this.getCategory()
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name
			}
			let str = ''
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--'
			}
			return str + ' ' +item.name;
		}
	},
	methods:{
		getCategory(){
			this.axios.get('/manage/category/tree').then(res=>{
				if(res.status){
					this.category = res.data
				}
			})
		},
		reset() {
		  this.form = {
			 name:'',
			 bn:'',
			 brand:'',
			 model:'',
			 guige:'',
			 nums:'',
			 cat_id:'',
			 unit:'',
			 procure_time:'',
			 price:'',
			 money:'',
			 gys_time:'',
			 procure_name:'',
			 expirare_date:[],
			 bx_date:[],
			 manufactor:'',
			 gbcode:'',
			 made_time:'',
			 wx_time:'',
			 batch:'',
			 sort:100,
			 status:1,
			 brief:'',
		  }
		  this.resetForm('form')
		},
		handleSubmit() {
		  this.$refs.form.validate(valid => {
		    if (valid) {
		      if (this.form.id === undefined) {
		        this.axios.post('/manage/'+this.preUrl + '/add', this.form).then(res => {
		          if (res.status) {
		            this.$message.success('添加成功')
		            this.$router.go(-1);
		          } else {
		            this.$message.error(res.msg)
		          }
		        })
		      } else {
		        this.axios.put('/manage/'+this.preUrl + '/edit/' + this.form.id, this.form).then(res => {
		          if (res.status) {
		            this.$message.success('修改成功')
		            this.$router.go(-1);
		          } else {
		            this.$message.error(res.msg)
		          }
		        })
		      }
		    }
		  })
		},
	},
}
</script>

<style>
</style>